import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../core/has.js";
import { isSome as e, isNone as t, unwrap as l } from "../../core/maybe.js";
import { loadArcade as r } from "../../support/arcadeOnDemand.js";
import { getCSSFilterFromEffectList as i, applyColorToSymbol as a, applySizesToSymbol as n, applyRotationToSymbol as o, getColorFromSymbol as s, applyOpacityToColor as c } from "./utils.js";
var u = null;

function y(e, t) {
  return Math.floor(Math.random() * (t - e + 1) + e);
}

function p(e, t, l) {
  var r = e.backgroundColor,
      i = e.outline,
      a = e.dotSize,
      n = l && l.swatchSize || 22,
      o = .8,
      s = Math.round(n * n / Math.pow(a, 2) * o),
      c = window.devicePixelRatio,
      p = document.createElement("canvas"),
      h = n * c;
  p.width = h, p.height = h, p.style.width = p.width / c + "px", p.style.height = p.height / c + "px";
  var b = p.getContext("2d");
  if (r && (b.fillStyle = r.toCss(!0), b.fillRect(0, 0, h, h), b.fill()), b.fillStyle = t.toCss(!0), u && u.length / 2 === s) for (var _y = 0; _y < 2 * s; _y += 2) {
    var _e = u[_y],
        _t = u[_y + 1];
    b.fillRect(_e, _t, a * c, a * c), b.fill();
  } else {
    u = [];

    for (var _e2 = 0; _e2 < 2 * s; _e2 += 2) {
      var _e3 = y(0, h),
          _t2 = y(0, h);

      u.push(_e3, _t2), b.fillRect(_e3, _t2, a * c, a * c), b.fill();
    }
  }
  i && (i.color && (b.strokeStyle = i.color.toCss(!0)), b.lineWidth = i.width, b.strokeRect(0, 0, h, h));
  var f = new Image(n, n);
  return f.src = p.toDataURL(), f;
}

function h(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var l = 24,
      r = 75,
      a = "horizontal" === t.align,
      n = a ? r : l,
      o = a ? l : r,
      _t$width = t.width,
      s = _t$width === void 0 ? n : _t$width,
      _t$height = t.height,
      c = _t$height === void 0 ? o : _t$height,
      _t$gradient = t.gradient,
      u = _t$gradient === void 0 ? !0 : _t$gradient,
      y = window.devicePixelRatio,
      p = s * y,
      h = c * y,
      b = document.createElement("canvas");
  b.width = p, b.height = h, b.style.width = "".concat(s, "px"), b.style.height = "".concat(c, "px");
  var f = b.getContext("2d"),
      d = a ? p : 0,
      m = a ? 0 : h;

  if (u) {
    var _t3 = f.createLinearGradient(0, 0, d, m),
        _l = e.length,
        _r = 1 === _l ? 0 : 1 / (_l - 1);

    e.forEach(function (e, l) {
      return _t3.addColorStop(l * _r, e.toString());
    }), f.fillStyle = _t3, f.fillRect(0, 0, p, h);
  } else {
    var _t4 = a ? p / e.length : p,
        _l2 = a ? h : h / e.length;

    var _r2 = 0,
        _i = 0;

    var _iterator = _createForOfIteratorHelper(e),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _n = _step.value;
        f.fillStyle = _n.toString(), f.fillRect(_r2, _i, _t4, _l2), _r2 = a ? _r2 + _t4 : 0, _i = a ? 0 : _i + _l2;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  var g = document.createElement("div");
  return g.style.width = "".concat(s, "px"), g.style.height = "".concat(c, "px"), g.style.filter = i(null == t ? void 0 : t.effectList), g.appendChild(b), g;
}

function b(_x, _x2) {
  return _b.apply(this, arguments);
}

function _b() {
  _b = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t) {
    var _yield$import, _l3, _yield$import2, _l4, _yield$import3, _l5, _yield$import4, _l6;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = e.type;
            _context.next = _context.t0 === "web-style" ? 3 : _context.t0 === "label-3d" ? 8 : _context.t0 === "line-3d" ? 8 : _context.t0 === "mesh-3d" ? 8 : _context.t0 === "point-3d" ? 8 : _context.t0 === "polygon-3d" ? 8 : _context.t0 === "simple-marker" ? 13 : _context.t0 === "simple-line" ? 13 : _context.t0 === "simple-fill" ? 13 : _context.t0 === "picture-marker" ? 13 : _context.t0 === "picture-fill" ? 13 : _context.t0 === "text" ? 13 : _context.t0 === "cim" ? 18 : 23;
            break;

          case 3:
            _context.next = 5;
            return import("./previewWebStyleSymbol.js");

          case 5:
            _yield$import = _context.sent;
            _l3 = _yield$import.previewWebStyleSymbol;
            return _context.abrupt("return", _l3(e, b, t));

          case 8:
            _context.next = 10;
            return import("./previewSymbol3D.js");

          case 10:
            _yield$import2 = _context.sent;
            _l4 = _yield$import2.previewSymbol3D;
            return _context.abrupt("return", _l4(e, t));

          case 13:
            _context.next = 15;
            return import("./previewSymbol2D.js");

          case 15:
            _yield$import3 = _context.sent;
            _l5 = _yield$import3.previewSymbol2D;
            return _context.abrupt("return", _l5(e, t));

          case 18:
            _context.next = 20;
            return import("./previewCIMSymbol.js");

          case 20:
            _yield$import4 = _context.sent;
            _l6 = _yield$import4.previewCIMSymbol;
            return _context.abrupt("return", _l6(e, t));

          case 23:
            return _context.abrupt("return");

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _b.apply(this, arguments);
}

function f(e) {
  return e && "opacity" in e ? e.opacity * f(e.parent) : 1;
}

function d(_x3, _x4) {
  return _d.apply(this, arguments);
}

function _d() {
  _d = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(i, s) {
    var c, u, y, p, h, _t5, b, d, _e4, m, g, w, S, v, _iterator2, _step2, _e7, V, x, R, C, _e5, _i2, _v, _e6;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (i) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            y = i.sourceLayer, p = null != (c = e(s) && null != (u = s.useSourceLayer) && u ? y : i.layer) ? c : y, h = f(p);

            if (!(e(i.symbol) && (!e(s) || !0 !== s.ignoreGraphicSymbol))) {
              _context2.next = 13;
              break;
            }

            if (!("web-style" === i.symbol.type)) {
              _context2.next = 10;
              break;
            }

            _context2.next = 7;
            return i.symbol.fetchSymbol(e(s) ? s.abortOptions : null);

          case 7:
            _context2.t0 = _context2.sent;
            _context2.next = 11;
            break;

          case 10:
            _context2.t0 = i.symbol.clone();

          case 11:
            _t5 = _context2.t0;
            return _context2.abrupt("return", (a(_t5, null, h), _t5));

          case 13:
            b = e(s) && s.renderer || p && "renderer" in p && p.renderer;

            if (!(b && "getSymbolAsync" in b)) {
              _context2.next = 20;
              break;
            }

            _context2.next = 17;
            return b.getSymbolAsync(i, s);

          case 17:
            _context2.t1 = _context2.sent;
            _context2.next = 21;
            break;

          case 20:
            _context2.t1 = null;

          case 21:
            d = _context2.t1;

            if (d) {
              _context2.next = 24;
              break;
            }

            return _context2.abrupt("return");

          case 24:
            if (!("web-style" === d.type)) {
              _context2.next = 30;
              break;
            }

            _context2.next = 27;
            return d.fetchSymbol(e(s) ? s.abortOptions : null);

          case 27:
            _context2.t2 = _context2.sent;
            _context2.next = 31;
            break;

          case 30:
            _context2.t2 = d.clone();

          case 31:
            d = _context2.t2;

            if (!(!("visualVariables" in b) || !b.visualVariables || !b.visualVariables.length)) {
              _context2.next = 34;
              break;
            }

            return _context2.abrupt("return", (a(d, null, h), d));

          case 34:
            if (!("arcadeRequiredForVisualVariables" in b && b.arcadeRequiredForVisualVariables && (t(s) || t(s.arcade)))) {
              _context2.next = 40;
              break;
            }

            _e4 = _objectSpread({}, l(s));
            _context2.next = 38;
            return r();

          case 38:
            _e4.arcade = _context2.sent;
            s = _e4;

          case 40:
            _context2.next = 42;
            return import("../../renderers/visualVariables/support/visualVariableUtils.js");

          case 42:
            m = _context2.sent;
            g = [];
            w = [];
            S = [];
            v = [];
            _iterator2 = _createForOfIteratorHelper(b.visualVariables);
            _context2.prev = 48;

            _iterator2.s();

          case 50:
            if ((_step2 = _iterator2.n()).done) {
              _context2.next = 64;
              break;
            }

            _e7 = _step2.value;
            _context2.t3 = _e7.type;
            _context2.next = _context2.t3 === "color" ? 55 : _context2.t3 === "opacity" ? 57 : _context2.t3 === "rotation" ? 59 : _context2.t3 === "size" ? 61 : 62;
            break;

          case 55:
            g.push(_e7);
            return _context2.abrupt("break", 62);

          case 57:
            w.push(_e7);
            return _context2.abrupt("break", 62);

          case 59:
            v.push(_e7);
            return _context2.abrupt("break", 62);

          case 61:
            _e7.target || S.push(_e7);

          case 62:
            _context2.next = 50;
            break;

          case 64:
            _context2.next = 69;
            break;

          case 66:
            _context2.prev = 66;
            _context2.t4 = _context2["catch"](48);

            _iterator2.e(_context2.t4);

          case 69:
            _context2.prev = 69;

            _iterator2.f();

            return _context2.finish(69);

          case 72:
            V = !!g.length && g[g.length - 1], x = V ? m.getColor(V, i, s) : null, R = !!w.length && w[w.length - 1];
            C = R ? m.getOpacity(R, i, s) : null;

            if (!(null != h && (C = null != C ? C * h : h), a(d, x, C), S.length)) {
              _context2.next = 78;
              break;
            }

            _e5 = m.getAllSizes(S, i, s);
            _context2.next = 78;
            return n(d, _e5);

          case 78:
            for (_i2 = 0, _v = v; _i2 < _v.length; _i2++) {
              _e6 = _v[_i2];
              o(d, m.getRotationAngle(_e6, i, s), _e6.axis);
            }

            return _context2.abrupt("return", d);

          case 80:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[48, 66, 69, 72]]);
  }));
  return _d.apply(this, arguments);
}

function m(_x5, _x6) {
  return _m.apply(this, arguments);
}

function _m() {
  _m = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(i, a) {
    var n, o, _t6, u, y, p, _e8, h, b, d, _iterator3, _step3, _e9, m, g, w, S;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (i) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return");

          case 2:
            o = f(i.layer || i.sourceLayer);

            if (!(e(i.symbol) && (!e(a) || !0 !== a.ignoreGraphicSymbol))) {
              _context3.next = 13;
              break;
            }

            if (!("web-style" === i.symbol.type)) {
              _context3.next = 10;
              break;
            }

            _context3.next = 7;
            return i.symbol.fetchSymbol(e(a) ? a.abortOptions : null);

          case 7:
            _context3.t0 = _context3.sent;
            _context3.next = 11;
            break;

          case 10:
            _context3.t0 = i.symbol.clone();

          case 11:
            _t6 = _context3.t0;
            return _context3.abrupt("return", s(_t6, o));

          case 13:
            u = e(a) && a.renderer || i.get("layer.renderer") || i.get("sourceLayer.renderer");
            _context3.next = 16;
            return u.getSymbolAsync(i, a);

          case 16:
            y = _context3.sent;

            if (y) {
              _context3.next = 19;
              break;
            }

            return _context3.abrupt("return");

          case 19:
            if (!("web-style" === y.type)) {
              _context3.next = 25;
              break;
            }

            _context3.next = 22;
            return y.fetchSymbol(e(a) ? a.abortOptions : null);

          case 22:
            _context3.t1 = _context3.sent;
            _context3.next = 26;
            break;

          case 25:
            _context3.t1 = y.clone();

          case 26:
            y = _context3.t1;
            p = s(y, o);

            if (!(!("visualVariables" in u) || "visualVariables" in u && !u.visualVariables || "visualVariables" in u && (null == (n = u.visualVariables) || !n.length))) {
              _context3.next = 30;
              break;
            }

            return _context3.abrupt("return", p);

          case 30:
            if (!(u.arcadeRequiredForVisualVariables && (t(a) || t(a.arcade)))) {
              _context3.next = 36;
              break;
            }

            _e8 = _objectSpread({}, l(a));
            _context3.next = 34;
            return r();

          case 34:
            _e8.arcade = _context3.sent;
            a = _e8;

          case 36:
            _context3.next = 38;
            return import("../../renderers/visualVariables/support/visualVariableUtils.js");

          case 38:
            h = _context3.sent;
            b = [];
            d = [];
            _iterator3 = _createForOfIteratorHelper(u.visualVariables);
            _context3.prev = 42;

            _iterator3.s();

          case 44:
            if ((_step3 = _iterator3.n()).done) {
              _context3.next = 54;
              break;
            }

            _e9 = _step3.value;
            _context3.t2 = _e9.type;
            _context3.next = _context3.t2 === "color" ? 49 : _context3.t2 === "opacity" ? 51 : 52;
            break;

          case 49:
            b.push(_e9);
            return _context3.abrupt("break", 52);

          case 51:
            d.push(_e9);

          case 52:
            _context3.next = 44;
            break;

          case 54:
            _context3.next = 59;
            break;

          case 56:
            _context3.prev = 56;
            _context3.t3 = _context3["catch"](42);

            _iterator3.e(_context3.t3);

          case 59:
            _context3.prev = 59;

            _iterator3.f();

            return _context3.finish(59);

          case 62:
            m = b.length > 0 ? b[b.length - 1] : null, g = m ? h.getColor(m, i, a) : p, w = d.length > 0 ? d[d.length - 1] : null;
            S = w ? h.getOpacity(w, i, a) : null;
            return _context3.abrupt("return", (null != o && (S = null != S ? S * o : o), g ? c(g, S) : null));

          case 65:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[42, 56, 59, 62]]);
  }));
  return _m.apply(this, arguments);
}

export { m as getDisplayedColor, d as getDisplayedSymbol, h as renderColorRampPreviewHTML, p as renderDotDensityPreviewHTML, b as renderPreviewHTML };